import { Component, HostListener, Input, OnDestroy, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'sia-iframe',
  templateUrl: './sia-iframe.component.html',
  styleUrls: ['./sia-iframe.component.css'],
  standalone: true,
})
export class SiaIframeComponent implements OnDestroy {
  private sanitizer = inject(DomSanitizer);

  sanitizedUrl: SafeResourceUrl = {};
  @Input() set url(uri: string) {
    if (uri && this.isValidUrl(uri)) {
      // For development, allow HTTP URLs but add warning
      if (uri.startsWith('http://') && !this.isLocalhost(uri)) {
        console.warn(
          'SiaIframeComponent: Loading HTTP content in iframe may cause authentication issues. Consider using HTTPS.',
        );
      }
      this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(uri);
    } else {
      console.error('SiaIframeComponent: Invalid URL provided:', uri);
      this.sanitizedUrl = {};
    }
  }
  @Input() frameHeight: Number = 0;

  private isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  private isLocalhost(url: string): boolean {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname === 'localhost' || urlObj.hostname === '127.0.0.1' || urlObj.hostname.endsWith('.local');
    } catch {
      return false;
    }
  }

  @HostListener('window:unload')
  ngOnDestroy() {
    this.sanitizedUrl = {};
  }
}
